/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllResidentsResponse } from './FindAllResidentsResponse';
import {
    FindAllResidentsResponseFromJSON,
    FindAllResidentsResponseFromJSONTyped,
    FindAllResidentsResponseToJSON,
} from './FindAllResidentsResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerResidents200Response
 */
export interface FindAllScreenerResidents200Response {
    /**
     * 
     * @type {FindAllResidentsResponse}
     * @memberof FindAllScreenerResidents200Response
     */
    data?: FindAllResidentsResponse;
}

/**
 * Check if a given object implements the FindAllScreenerResidents200Response interface.
 */
export function instanceOfFindAllScreenerResidents200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerResidents200ResponseFromJSON(json: any): FindAllScreenerResidents200Response {
    return FindAllScreenerResidents200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerResidents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerResidents200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllResidentsResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerResidents200ResponseToJSON(value?: FindAllScreenerResidents200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllResidentsResponseToJSON(value.data),
    };
}

